<script setup lang="ts">
import { onMounted } from 'vue'
import { RouterView } from 'vue-router'
import { useAppStore } from '@/stores/app'
import { useNavMeusStore } from '@/stores/nav-menus'

const appStore = useAppStore()
const navMeusStore = useNavMeusStore()

const pathMap: Record<string, string> = {
  '/download': '#/download',
  // '/solutions#service#': '/solutions',
  '/deskoX1Video.html': '#/deskoX1Video'
}

const jumpUrl = (url: string) => {
  console.log(url);
  window.location.href = pathMap[url] || url
}

onMounted(() => {
  appStore.initApp()
  navMeusStore.refreshNavMenus()
  if (!!pathMap[window.location.pathname]) {
    jumpUrl(pathMap[window.location.pathname])
  }

})
</script>

<template>
  <RouterView v-slot="{ Component, route }">
    <component :is="Component" :key="route.path" />
  </RouterView>
</template>

<style scoped lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
